import React from "react";
import { FormConfiguration } from "../../FormConfiguration";
import { FormRuntime } from "../../FormRuntime";
import { TagGroupFormControl } from "../Web/TagGroupFormControl";
import { XColumnContainer, XColumnContainerColumn } from "../../Containers";
import { LabelFormControl } from "../Web/LabelFormControl";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";

function getUI(): { form: FormConfiguration } {
    let ui = new FormConfiguration();
    let container = new XColumnContainer();
    let col = new XColumnContainerColumn();

    container.add(col);
    ui.add(container);

    let label = new LabelFormControl();
    label.text = "Tag Selection";
    col.add(label);

    let textField = new TagGroupFormControl();
    textField.label = "Text Field Label";
    textField.valueName = "tag";
    textField.list = ["Upwork", "HubStaff", "Appglue"];
    textField.requiredOnAllOutcomes = false;
    col.add(textField);

    textField = new TagGroupFormControl();
    textField.label = "Text Field Label";
    textField.valueName = "tag";
    textField.list = ["Upwork", "HubStaff", "Appglue"];
    textField.requiredOnAllOutcomes = true;
    col.add(textField);

    return { form: ui };
}

export const TagGroupStories = [
    new StoryNode(
        () => {
            let ui = getUI();

            let controls = ui.form.getAllControls();

            for (let c of controls) {
                let ctf = c as TagGroupFormControl;
                if (ctf) {
                    ctf.allowedNewTag = true;
                }
            }
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Tag Group",
        "Allow New Tag"
    ),

    new StoryNode(
        () => {
            let ui = getUI();

            let controls = ui.form.getAllControls();

            for (let c of controls) {
                let ctf = c as TagGroupFormControl;
                if (ctf) {
                    ctf.allowedNewTag = false;
                }
            }
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Tag Group",
        "Not Allow New Tag"
    ),

    new StoryNode(
        () => {
            let ui = getUI();

            let controls = ui.form.getAllControls();

            for (let c of controls) {
                let ctf = c as TagGroupFormControl;
                if (ctf) {
                    ctf.requiredOnAllOutcomes = true;
                }
            }
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Tag Group",
        "With Validation"
    ),
];
